import { extend, configure } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import moment from 'moment'
import i18n from '@/lang'
//@ts-ignore
import _ from 'lodash'
const emojiRegex = require('emoji-regex');

// install rules and localization
for (const [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation
  })
}

configure({
  defaultMessage: (field, values) => {
    // override the field name.
    if (!field.includes('ignore')) {
      values._field_ = i18n.t(`fields.${field}`)
    }
    return i18n.t(`validation.${values._rule_}`, values) as string
  }
})

extend('max', {
  validate(value: any, event: any) {
    return new Blob([value]).size <= (event.length * 4) && _.toArray(value).length <= event.length
  }
})

extend('min_date', {
  params: ['min', 'date_format'],
  validate(value, event: any) {
    return moment(value).isAfter(moment(event.min))
  }
})

extend('max_date', {
  params: ['max', 'date_format'],
  validate(value, event: any) {
    return moment(value).isBefore(moment(event.max))
  }
})

export const emailRegex = /^(?!.*\.\.)[a-zA-Z0-9_-](?:[a-zA-Z0-9._-]*[a-zA-Z0-9_-])?@(?:[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,63}$/
extend('email', {
  validate(value) {
    return emailRegex.test(value)
  },
})

extend('check_password', {
  validate(value) {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,}$/
    return passwordRegex.test(value)
  },
})

extend('check_kana', {
  validate(value) {
    const kanaRegex = /^[\u3040-\u309f]*$/
    return kanaRegex.test(value)
  }
})

extend('check_email', {
  params: ['target'],
  validate(value, target: any) {
    return value !== target.target
  },
})

extend('duplicate_orignal_email', {
  params: ['target'],
  validate(value, target: any) {
    return value !== target.target
  },
})

extend('postal_code', {
  validate(value) {
    const postalRegex = /^\d{3}\d{4}$/
    return postalRegex.test(value)
  }
})

extend('text_number_halfwidth_only', {
  validate(value) {
    const regex = /^[a-zA-Z0-9]+$/
    return regex.test(value)
  }
})

extend('phone_number', {
  validate(value) {
    const verifyPhone = /^\d{10,11}$/
    return verifyPhone.test(value)
  }
})

extend('url', {
  validate(value: string | null | undefined): boolean {
    if (value) {
      return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(value);
    }

    return false;
  },
})

/**
 * @denied emoji
 * @denied keep enter
 * @denied special characters
 */
extend('text_number_only', {
  validate(value) {
    const textNumberRegex = /^[a-zA-Z0-9-ぁ-んァ-ン一ー-龥ｧ-ﾝﾞﾟ ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳýỵỷỹ]+$/
    return textNumberRegex.test(value)
  }
})

/**
 * @denied emoji
 * @denied space
 * @denied keep enter
 * @denied special characters
 */
extend('text_number_only_no_space', {
  validate(value) {
    const textNumberRegex = /^[a-zA-Z0-9-ぁ-んァ-ン一ー-龥ｧ-ﾝﾞﾟÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳýỵỷỹ]+$/
    return textNumberRegex.test(value)
  }
})

/**
 * @denied emoji
 */
extend('no_emoji', {
  validate(value) {
    return !emojiRegex().test(value)
  }
})

extend('compare_start_end_time', {
  params: ['target'],
  validate(value, target: any) {
    return value > target.target;
  },
})


export const checkScript = (value: string) => ((value.includes('<script') && value.includes('</script')) || value.includes('<?') || value.includes('<%'))
extend('no_script_tag', {
  validate(value) {
    return !checkScript(value)
  }
})

extend('min_password', {
  params: ['min'],
  validate(value, { min }: any) {
    return value?.length >= min
  },
})

extend('maxLengthCharacter', {
  params: ['max'],
  validate(value, { max }: any) {
    if (!value) return true

    // @ts-ignore
    const segmenter = new Intl.Segmenter('ja', { granularity: 'grapheme' })
    const count = [...segmenter.segment(value)].length
    return count <= max
  },
  message: (field, values) => {
    return i18n
      .t('common.message.like_text_validation', { max: values.max })
      .toString()
  }
})
